export const en = {
  afterLeverage: 'After Leverage',
  all: 'All',
  amount: 'Amount',
  balance: 'Balance',
  buy: 'Buy',
  cancel: 'Cancel',
  canceled: 'Canceled',
  change: 'Change',
  close: 'Close',
  closeAll: 'Close All',
  closeAllPositionsMessage: 'Are you sure you want to close ALL positions?',
  closedPositions: 'Closed Positions',
  tradeHistory: 'Trade History',
  closePosition: 'Close Position',
  closePositionMessage: 'Are you sure you want to close this position?',
  closePositionSuccessMessage: 'Order %{order} has been closed',
  closePrice: 'Close Price',
  closingPosition: 'Closing Position',
  closingPositions: 'Closing Positions',
  commodities: 'Commodities',
  communicationProblems: 'Communication problems',
  confirm: 'Confirm',
  connectingToServer: 'Connecting to server',
  crypto: 'Crypto',
  currentPrice: 'Current Price',
  currentRate: 'Current Rate',
  dashboard: 'Dashboard',
  datafeedConfiguration:
    'Unsupported datafeed configuration. Must either support search, or support group request',
  demo: 'Demo',
  deposit: 'Deposit',
  depositAmount: 'DEPOSIT AMOUNT',
  description: 'Description',
  direction: 'Direction',
  equity: 'Equity',
  bonus: 'Bonus',
  error: 'Error',
  failed: 'Failed',
  failedPositionClose: 'Position not found',
  failedPositionUpdate: 'An error occurred. Please try again',
  failedUpload: 'Something went wrong, please try again',
  forex: 'Forex',
  freeMargin: 'Free margin',
  genericErrorMessage: 'Something went wrong',
  graphQLError: '[GraphQL error]: Message: %{message}, Location %{location}, Path: %{path}',
  graphQLNetworkError: '[Network error]: %{networkError}',
  helpBalance:
    'Your Accounts value excluding the P&L from open positions. It equals the funds you deposited into your account and your P&L from closed positions.',
  helpEquity:
    'Your current accounts value: It equals your balance, plus any P&L from open positions.',
  helpBonus: 'Your current account bonus value.',
  helpFreeMargin:
    'The sum of funds available to use as initial margin for new positions. Calculated subtracting the margin used by your current open positions from your equity.',
  helpInitialMargin: 'Indicated the minimum free margin to open the position.',
  helpLeverage:
    'Leverage enables you to place a trade with more than the funds you have deposited into your account. For example if you have €100 in your account a leverage of 1:200 will allow you to place a €20,000 trade. Leverage may be adjusted through your settings depending on your appropriateness test.',
  helpSpread: 'The difference between ASK and BID price.',
  helpStopLoss:
    "A Stop Loss is used to limit a trader's losses if the market moves against their position. It’s a protective order that closes an open position (or future position) when a predetermined asset price is reached.",
  helpTakeProfit:
    "Take Profit is used to lock in the trader's profit if the market moves favourably. The trader sets in an open position (or future position) the price at which he wants to close his position, and once that profit point is reached, the position is closed.",
  helpUsedMargin:
    'Indicated the sum of the margin used by your open positions. Calculated by adding or summing all of the initial margins of your open positions.',
  helpMarginLevel:
    'The margin level is the relation between a trader’s funds and the margin (expressed as a percentage). The margin level can be calculated using the following formula: Margin Level = (Equity / Used Margin) x 100%',
  helpValue: 'This is the total value of your trade in the market place after leverage.',
  helpOpenPrice:
    'Set a level to open a pending order that will be executed when the asset’s price reaches it',
  indices: 'Indices',
  insufficientMargin: 'Insufficient Margin. Please add additional funds',
  invalidOrder: 'Invalid order',
  invalidSymbol: 'invalid symbol',
  invested: 'Invested',
  investment: 'Investment',
  investmentAmount: 'INVESTMENT AMOUNT',
  investmentAmountError: 'Investment amount is too low',
  islamic: 'Islamic',
  leverage: 'Leverage',
  live: 'Live',
  loaderBdswiss: 'Your team at BDSwiss',
  loaderMsg1: 'Have a wonderful trading session!',
  loaderMsg2: 'Thank you for choosing BDSwiss, we appreciate it!',
  loaderMsg3: 'Please let us know if there are ways to improve your experience!',
  loaderMsg4: 'Thanks for trading with BDSwiss!',
  loaderMsg5: 'We appreciate the trust you place in BDSwiss!',
  loaderMsg6: 'With so many choices, we thank you for choosing us!',
  lots: 'lots',
  lots_1: 'lot',
  margin: 'Margin',
  marginLevel: 'Margin level',
  marketClosed: 'Trade is disabled or market is closed',
  multiplier: 'Multiplier',
  name: 'Name',
  noRatesChain: "Can't find chain of rates",
  nothingToChange: "Your order wasn't save because you haven't made any changes",
  noClosedPositions: 'No closed positions',
  noOpenPositions: 'No open positions',
  noUrlError: 'No url has been provided',
  openPositions: 'Open Positions',
  openPrice: 'Open Price',
  openRate: 'Open Rate:',
  orderId: 'Order #',
  placeTrade: 'Place trade',
  popular: 'Popular',
  position: 'Position',
  positions: 'Positions',
  positionSettings: 'Position Settings',
  positionWasUpdated: 'Order %{order} has been updated',
  practiceAccount: 'Practice Account',
  price: 'Price',
  profit: 'Profit',
  realAccount: 'Real Account',
  centAccount: 'Cent Account',
  reloadTrades: 'Confirm to reload trades',
  requiredMargin: 'Required Margin',
  save: 'Save',
  saveChanges: 'Save changes',
  searchAsset: 'Search Assets',
  selectAssets: 'Select Assets',
  sell: 'Sell',
  shares: 'Shares',
  socketConnectionError: 'Socket connection should be opened once',
  spread: 'Spread',
  stopLoss: 'Stop Loss',
  success: 'Success',
  successfulOrderPlacement: 'New %{type} order %{order} has been placed',
  swaps: 'Swaps',
  symbolStorageConfiguration: 'Symbols storage has inconsistent configuration',
  takeProfit: 'Take Profit',
  taxes: 'Taxes',
  totalPositionSize: 'Total Position Size:',
  type: 'Type',
  urlSetError: 'URL should be set once',
  value: 'Value',
  websocketConnectionError: 'Websocket connection should be established',
  websocketConnectionFailed: 'Connection with server is lost',

  // new translations that do not exist on server yet
  practiceBondsAccount: 'Practice Bonds Account',
  bondsAccount: 'Bonds Account',
  company: 'Company',
  paidInterest: 'Paid Interest',
  accruedInterest: 'Accrued Interest',
  coupon: 'Coupon',
  cash: 'Cash',
  principal: 'Principal',
  marketValue: 'Principal Amount',
  status: 'Status',
  orderTicket: 'Order Ticket',
  pricePer: 'Price per %{currency}100',
  totalCost: 'Total Position',
  cashAmount: 'Cash amount',
  principalAmount: 'Principal Amount',
  totalPosition: 'Total Position',
  ISIN: 'ISIN',
  currentYield: 'Current Yield',
  estimatedYieldToMaturity: 'Estimated Yield to Maturity',
  maturityDate: 'Maturity Date',
  interestPaymentFrequency: 'Interest Payment Frequency',
  nextInterestPayment: 'Next Payment Date',
  assetSecurity: 'Asset Security',
  industryType: 'Industry Type',
  nextCall: 'Next Call',
  businessDescription: 'Business Description',
  ytm: 'YTM',
  placeOrder: 'Place Order',
  allPaymentsOnTime: 'All payments are on time',
  allCoveandsMet: 'All covenants met',
  selectInvestmentType: 'Select Investment Type',
  backToBondList: 'Back to Bond List',
  showChart: 'Show Chart',
  hideChart: 'Hide Chart',
  leveragedInterest: 'Annual Net Interest',
  yourCapitalIsAtRisk: 'Your capital is at risk',
  requiredFunds: 'Funds required to open position',
  marginRequirement: 'Margin Requirement + Accrued Interest',
  yearlyLeveragedInterest: 'Annual Net Interest',
  yearlyInterestEarnings: 'Annual Net Interest Earnings',
  advanced: 'Advanced',
  interestPaymentNote: 'interest payments may take up to 24 hours to settle',
  bondBuyModeDisclamer:
    '* The cost might not be exactly the same as your investment amount because of rounding',
  readMore: 'Read more',
  helpPlaceIfPrice: '',
  pendingOrders: 'Pending Orders',
  noPendingOrders: 'No Pending Orders',
  scheduleOrder: 'Schedule order',
  successfulPendingOrderPlacement: 'New %{type} pending order %{order} has been placed',
  activatedPositionSuccessMessage: 'Pending order %{order} has been activated',
  canceledPositionSuccessMessage: 'Pending order %{order} has been canceled',
  pendingPositionWasUpdated: 'Pending order %{order} has been updated',
  cancelingPosition: 'Canceling Position',
  cancelPositionMessage: 'Are you sure you want to cancel this position?',
  tradingPanelAdvancedSettings: 'Advanced Settings',
  trade: 'Trade',
  loss: 'Loss',
  order: 'Order',
  favourites: 'Favourites',
  viewDetails: 'View Details',

  // bond detailed view dialog
  bdd_line1:
    'You are purchasing a Bond CFD which will pay you leveraged interest on the underlying:',
  cashToOpenPosition: 'Cash to open position',
  cashToOpenPositionDescription: 'The total of Margin requirement plus Accrued Interest.',
  leveragedAccuredInterest: 'Leveraged Accrued Interest',
  leveragedAccuredInterestDescription:
    'The total amount of interest the underlying bond accrued since the last payment. You will receive this back when you sell the bond plus any additional interest accrued while holding the bond. The accrued interest must be paid when purchasing the bond.',
  leveragedAccuredInterestFormula:
    'Days Since last payment / 365 * Total Principal Debt Amount * Nominal Bond Interest Coupon =Leveraged Accrued Interest',
  leveragedAccuredInterestTable1: 'Days since last payment',
  leveragedAccuredInterestTable2: 'Total Principal Debt Amount',
  leveragedAccuredInterestTable3: 'Nominal Bond Interest Coupon ',

  accountLeverage: 'Account Leverage',
  accountLeverageDescription:
    'You are able to open a Total Position Value which is %{leverage} times the margin requirement',

  totalPositionValue: 'Total Position Value',
  totalPositionValueDescription:
    'This is the total BOND CFD position size you are to buy in the market place upon opening.',
  totalPositionValueFormula:
    '(Cash to Open Position – Leveraged Accrued interest) * Account Leverage = Total Position Value',
  totalPositionValueTable1: 'Cash to open position',
  totalPositionValueTable2: 'Leveraged Accrued Interest',
  totalPositionValueTable3: 'Account Leverage',
  totalPositionValueTable4: 'Total Position Value',

  marginUsed: 'Margin Used',
  marginUsedDescription:
    'Account Margin used represents the amount of funds used to open the position without taking into account accrued interest.',
  marginUsedFormula: 'Cash to open position – Acrrued Interest = Margin Used',
  marginUsedTable1: 'Cash to open Position',
  marginUsedTable2: 'Accrued Interest',

  marginStopOutLevel: 'Margin Stop Out Level',
  marginStopOutLevelDescription:
    'If the value of the underlying Total Position Size drops by 50% of your Initial Margin Requirement you will be required to post additional margin to keep the trade open or the position will be liquidated.',

  marginFinancingRate: 'Margin Financing Rate',
  marginFinancingRateDescription:
    'The annual interest rate paid by you to BDSwiss for the leverage. On a 1:3 Account Leverage you are paying this interest on 2:3 of your Total Position Value',

  tradeFinancingCost: 'Annual Trade Financing Cost',
  tradeFinancingCostDescription: 'The annual interest to BDSwiss for the leverage',
  tradeFinancingCostFormula: '(Total Position Value – Margin Used)  * Margin Financing Rate ',

  tradeFinancingCostTable1: 'Total Position Value',
  tradeFinancingCostTable2: 'Margin Used',
  tradeFinancingCostTable3: 'Margin Financing Rate',

  currentRateTitle: 'Current Rate',
  currentRateDescription:
    'The Market Rate of the underlying bond. Market rate is defined as price per €100 of Principal Debt. This is the cost to acquire each €100 of Principal Debt on which you will earn interest. The Market rate fluctuates depending on market conditions. ',

  totalDebtAmount: 'Total Principal Debt Amount',
  totalDebtAmountDescription:
    'This is the Total Amount of Underlying Debt on which you will earn the Nominal Bond Interest Coupon',
  totalDebtAmountFormula:
    '(Total Position Value / Current Rate) * 100€ = Total Principal Debt Amount',
  totalDebtAmountTable1: 'Total Position Value',
  totalDebtAmountTable2: 'Current Rate',

  nominalBondInterestCoupon: 'Nominal Bond Interest Coupon',
  nominalBondInterestCouponDescription:
    'Interest paid by the underlying bond on your Total Principal Amount',

  annualInterestEarnings: 'Annual Interest Earnings',
  annualInterestEarningsDescription: 'The annual interest you will earn on the Bond CFD',
  annualInterestEarningsFormula:
    'Total Principal Debt Amount   * Nominal Bond Interest Coupon = Annual Interest Earnings',
  annualInterestEarningsTable1: 'Total Principal Debt Amount',
  annualInterestEarningsTable2: 'Nominal Bond Interest Coupon',

  netInterestEarnings: 'Annual Net Interest Earnings',
  netInterestEarningsDescription: 'The annual interest earning after trade financing costs',
  netInterestEarningsFormula:
    'Annual Interest Earnings – Annual Trade Finance Costs = Annual Net Interest Earnings',
  netInterestEarningsTable1: 'Annual Interest Earnings',
  netInterestEarningsTable2: 'Annual Trade Finance Costs',
  bondNetInterestDescription:
    'Annual interest earning projection after deduction of accrued interest and trade financing costs.',
  yr: 'yr.',
  perpetual: 'Perpetual',
  positionDetails: 'Position Details',
  interestDetails: 'Interest Details',

  more: 'More',
  less: 'Less',
  lotsAmount: 'Lots',

  toggleAssets: 'Assets',
  togglePositions: 'Open Positions',
  togglePendingOrders: 'Pending Orders',
  toggleTradeHistory: 'Trade History',
  asset: 'Asset',
  openDate: 'Open Date',
  closeDate: 'Close Date',
  edit: 'Edit',
  noItemsToDisplay: 'No items to display',
  clear: 'Clear',
  showMore: 'Show More',
  showLess: 'Show Less',
  commission: 'Commission',
  switchToBuy: 'Switch to Buy',
  switchToSell: 'Switch to Sell',
  backToDashboard: 'Back to dashboard',
  signals: 'Signals',
  search: 'Search',
  UP: 'UP',
  DOWN: 'DOWN',
  distance: 'Distance',
  priceDistance: 'Distance from current price',
  sellPrice: 'Sell at',
  buyPrice: 'Buy at',
  complete: 'Complete',
  yes: 'Yes',
  no: 'No',
  emerging: 'Emerging',
  resolution: 'Resolution',
  riskDisclaimer: 'risk disclaimer',
  signalsRiskDisclaimer:
    'All signals are provided by Autochartist and should not be considered as trading or investment advice. Past performance is not an indication of future performance. Please read our %{riskDisclaimer} for more information.',
  leveragedLabel: 'L',
  unleveragedLabel: 'UN',
  tradingViewAttributionLinkText: '%{symbol} chart by TradingView',
  errorLoadingChartData: 'Error loading chart data, please refresh the page',
  fundamentalAnalysis: 'Fundamental Analysis',
  analysisNotAvailableTooltip: 'There is no analysis available for this asset.',
  refinitiv_analystConsensus_title: 'Analyst Consensus',
  refinitiv_analystConsensus_strongsell: 'Strong Sell',
  refinitiv_analystConsensus_sell: 'Sell',
  refinitiv_analystConsensus_hold: 'Hold',
  refinitiv_analystConsensus_buy: 'Buy',
  refinitiv_analystConsensus_strongbuy: 'Strong Buy',
  refinitiv_analystConsensus_targetTitle: 'Difference to Target Price',
  refinitiv_analystConsensus_low: '52W Low',
  refinitiv_analystConsensus_high: '52W High',
  refinitiv_analystConsensus_price: 'price',
  refinitiv_analystConsensus_tp: 'TP',
  refinitiv_analystConsensus_recommendation: 'Recommendation',
  refinitiv_analystConsensus_tpfull: 'Target Price',
  refinitiv_analystConsensus_pltg: 'Projected LT Growth',
  refinitiv_titles_companyInfo: 'Company Information',
  refinitiv_titles_total: 'Total',
  refinitiv_titles_valuationProfit: 'Valuation & profitability',
  refinitiv_titles_forecast: 'Forecast',
  refinitiv_titles_current: 'Current',
  refinitiv_titles_perShareData: 'Per Share Data',
  refinitiv_table_marketCap: 'Market capitalization',
  refinitiv_table_sharesOutstanding: 'Shares outstanding',
  refinitiv_table_commonshare: 'Common Shareholders',
  refinitiv_table_enterpriseValue: 'Enterprise Value',
  refinitiv_table_numberEmployees: 'Number of Employees',
  refinitiv_table_pe: 'P/E Ratio',
  refinitiv_table_ps: 'P/S Ratio',
  refinitiv_table_pb: 'P/BV Ratio',
  refinitiv_table_pcf: 'P/CF Ratio',
  refinitiv_table_peg: 'PEG',
  refinitiv_table_earningYield: 'Earnings Yield',
  refinitiv_table_dividendYield: 'Dividend Yield',
  refinitiv_table_revenue: 'Revenue',
  refinitiv_table_ebit: 'EBIT',
  refinitiv_table_netIncome: 'Net Income',
  refinitiv_table_gpm: 'Gross Profit Margin',
  refinitiv_table_roe: 'Return on Equity',
  refinitiv_table_eps: 'Earnings per Share',
  refinitiv_table_rps: 'Revenues per Share',
  refinitiv_table_bps: 'Book Value per Share',
  refinitiv_table_cfps: 'Cash flow per Share',
  refinitiv_table_cps: 'Cash per Share',
  refinitiv_table_dividendPerShare: 'Dividend per share',
  refinitiv_table_captions_companyInfo: 'Table showing the company information',
  refinitiv_table_captions_valuationProfit: 'Table showing the value and profitabiliy ratios',
  refinitiv_table_captions_perShareData: 'Table showing the per share data',
  refinitiv_table_captions_total: 'Table showing the total data',
  refinitiv_messages_nodata:
    'No data available for this exchange. Probably not operating at this time.',
  refinitiv_messages_error:
    'There was an error. We will try to get the data again in a few moments...',
  refinitiv_numberFormats_compact: ',,,0.0K,00K,000K,0.0M,00M,000M,0.0B,00B,000B,0.0T,00T,000T',
  refinitiv_titles_masterData: 'Master Data',
  refinitiv_titles_clearingCodes: 'Clearing Codes',
  refinitiv_titles_keyDates: 'Key Dates',
  refinitiv_titles_activities: 'Activities',
  refinitiv_titles_management: 'Management',
  refinitiv_table_symbol: 'Symbol',
  refinitiv_table_name: 'Name',
  refinitiv_table_companyID: 'Company ID',
  refinitiv_table_price: 'Price',
  refinitiv_table_currency: 'Currency',
  refinitiv_table_exchange: 'Exchange',
  refinitiv_table_parValue: 'Par value',
  refinitiv_table_freeFloat: 'Free Float in %',
  refinitiv_table_employees: 'Employees',
  refinitiv_table_headquarters: 'Company Headquarters',
  refinitiv_table_phone: 'Telephone',
  refinitiv_table_fax: 'Fax',
  refinitiv_table_internet: 'Internet',
  refinitiv_table_isin: 'ISIN',
  refinitiv_table_valor: 'Securities',
  refinitiv_table_cusip: 'CUSIP',
  refinitiv_table_finYearEnd: 'Fiscal year end',
  refinitiv_table_reportingDateQ3: 'Quarterly figures III',
  refinitiv_table_reportingDateQ4: 'Quarterly figures IV',
  refinitiv_table_reportingDateQ1: 'Quarterly figures I',
  refinitiv_table_reportingDateQ2: 'Quarterly figures II',
  refinitiv_table_reportingDateA: 'Prelim. year-end report',
  refinitiv_table_captions_masterData: 'Table showing the master data',
  refinitiv_table_captions_clearingCodes: 'Table showing the clearing codes',
  refinitiv_table_captions_keyDates: 'Table showing key dates',
  refinitiv_table_captions_activities: 'Section showing activities',
  refinitiv_table_captions_management: 'Table showing management details',
  refinitiv_a11y_controlBar: 'Widget Control Bar',
}
